var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.39 32h-2.058L8 8h4.797l2.316 15.188L17.992 8h4.033l2.884 15.172L27.219 8H32l-4.299 24h-4.863l-2.83-14.291L17.162 32H14.39z",
  fill: "#3A1E44"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuMzkgMzJIMTIuMzMxOUw4IDhIMTIuNzk2N0wxNS4xMTM0IDIzLjE4ODFMMTcuOTkxNyA4SDE5LjQ4NTVIMjAuNTQ3OEgyMi4wMjQ5TDI0LjkwODYgMjMuMTcyM0wyNy4yMTk5IDhIMzJMMjcuNzAxMyAzMkgyNS42MUgyNC42MzA3SDIyLjgzODJMMjAuMDA3OSAxNy43MDg5TDE3LjE2MTkgMzJIMTUuMzg1OUgxNC4zOVoiIGZpbGw9IiMzQTFFNDQiLz4KPC9zdmc+Cg==";
export { SvgWhite as ReactComponent };